<template>
  <main class="yj-main">
    <slot></slot>
  </main>
</template>

<script>
  export default {
    name: 'YjMain',
    componentName: 'YjMain'
  };
</script>



// WEBPACK FOOTER //
// src/components/main/src/main.vue